import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";
import { IframeRequestModalProps } from "./types";
import IframeRequestScreen from "./iFrameRequestScreen";
import { DynamicFormProvider } from "@scenes/bulk-request/context/DynamicFormContext";
import { SpaceType } from "@components/atoms/Spacer/types";

const IframeRequestModal = ({
  isOpen,
  onClose,
  itemDetail,
  onSuccess,
  productType,
}: IframeRequestModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      headerTitle={t("iframe.title.text")}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={SpaceType.Double}
      paddingRight={SpaceType.Double}
      paddingTop={SpaceType.Big}
      paddingBottom={SpaceType.ExtraLarge}
    >
      <DynamicFormProvider>
        <IframeRequestScreen
          itemDetail={itemDetail}
          onClose={onClose}
          onSuccess={onSuccess}
          productType={productType}
        />
      </DynamicFormProvider>
    </Modal>
  );
};

export default IframeRequestModal;
